import React from 'react'

const NoMatch = () => (
	<div>We could not find that page</div>
)

export default NoMatch


// WEBPACK FOOTER //
// ./src/components/NoMatch.js